module.exports = __webpack_public_path__ + "img/t5-1.0da5fd5e.svg";